{
  "hero": {
    "title": "Prețuri"
  },
  "intro": {
    "title": "Execuție rapidă, tarife clare, valoare măsurabilă.",
    "subtitle": "Față de agențiile mari: accesibilitate, colaborare directă și expertiză specializată în video pentru platformele actuale."
  },
  "promo": {
    "discount": "-50%",
    "title": "PENTRU PRIMUL VIDEOCLIP CORPORATIV SAU DE RECRUTARE",
    "location": "*FILMĂRILE SUNT POSIBILE DOAR ÎN MÜNCHEN, GERMANIA (+ 100KM).",
    "cta": "SOLICITĂ OFERTA"
  },
  "tabs": {
    "subscription": "Abonament",
    "perProject": "Per proiect"
  },
  "subscription": {
    "intro": "Videografie, design și dezvoltare full-stack, fără contract de durată.",
    "packages": {
      "essential": {
        "title": "1. Pachet Essential",
        "prices": "10-15 ore/lună (€700–€1.000/lună)",
        "deliverables": "Livrabile:",
        "items": [
          "VIDEOGRAFIE: Videoclip promoțional scurt, Videoclipuri corporative/de recrutare, Pachet social media și altele",
          "DESIGN GRAFIC: Pachet branding, Marketing și publicitate, Design print și altele",
          "Timp de răspuns mai mic de 24 de ore"
        ]
      },
      "advanced": {
        "title": "2. Pachet Advanced",
        "prices": "20-30 ore/lună (€1.500–€2.000/lună)",
        "deliverables": "Livrabile:",
        "items": [
          "VIDEOGRAFIE: Videoclip promoțional, Videoclipuri corporative/de recrutare, Pachet social media și altele",
          "MOTION GRAPHICS: Animații personalizate, animații ușoare, design sonor și altele",
          "DESIGN GRAFIC: Pachet branding, Marketing și publicitate, Design print și altele",
          "UI/UX DESIGN: Strategie, Grafică și layout-uri website, Design interfață utilizator (UI) și altele",
          "Timp de răspuns mai mic de 24 de ore"
        ]
      },
      "elite": {
        "title": "3. Pachet Elite",
        "prices": "40-65 ore/lună (€3.000–€4.500/lună)",
        "deliverables": "Livrabile:",
        "items": [
          "VIDEOGRAFIE: Videoclip promoțional, Videoclipuri corporative/de recrutare, Pachet social media și altele",
          "MOTION GRAPHICS: Animații personalizate, animații ușoare, design sonor și altele",
          "DESIGN GRAFIC: Pachet branding, Marketing și publicitate, Design print și altele",
          "UI/UX DESIGN: Strategie, Grafică și layout-uri website, Design interfață utilizator (UI) și altele",
          "DEZVOLTARE: Dezvoltare pagină de destinație simplă, Mentenanță website, Redesign complet website și altele",
          "Timp de răspuns mai mic de 8 ore"
        ]
      }
    }
  },
  "perProject": {
    "intro": "Flexibilitate și soluții personalizate pentru obiective specifice.",
    "video": {
      "title": "VIDEO",
      "items": {
        "promo": {
          "title": "Videoclip promoțional scurt",
          "price": "Interval de preț: €500–€1.000",
          "features": [
            "Asistență scenariu.",
            "Filmare sau editare a materialului furnizat.",
            "Animații de bază sau subtitrări."
          ]
        },
        "corporate": {
          "title": "Videoclipuri corporative/de recrutare",
          "price": "Interval de preț: €1.200–€2.500",
          "features": [
            "Filmare la fața locului (1 zi).",
            "Editare avansată și motion graphics.",
            "Opțiuni de branding personalizat și voiceover."
          ]
        },
        "social": {
          "title": "Pachet social media (3 videoclipuri scurte)",
          "price": "Interval de preț: €500–€1.000",
          "features": [
            "Conținut scurt și atractiv adaptat pentru platforme precum Instagram, LinkedIn sau TikTok.",
            "Livrare rapidă pentru marketing bazat pe tendințe."
          ]
        }
      }
    },
    "graphicDesign": {
      "title": "DESIGN GRAFIC",
      "items": {
        "branding": {
          "title": "Pachet branding",
          "price": "Interval de preț: €1.000–€1.500",
          "features": ["Design logo", "Cărți de vizită", "2 materiale de marketing"]
        },
        "marketing": {
          "title": "Marketing și publicitate",
          "price": "Preț: €70/oră",
          "features": [
            "Design broșură și flyer",
            "Design poster",
            "Bannere publicitare (Web și Print)",
            "Grafică social media",
            "Design newsletter email"
          ]
        },
        "webDigital": {
          "title": "Design web și digital",
          "price": "Preț: €70/oră",
          "features": [
            "Grafică și layout-uri website",
            "Design interfață utilizator (UI)",
            "Design iconiță aplicație",
            "Infografice",
            "Design e-book"
          ]
        },
        "print": {
          "title": "Design print",
          "price": "Preț: €70/oră",
          "features": [
            "Layout-uri revistă și ziar",
            "Design copertă carte",
            "Invitații și carduri eveniment",
            "Semnalizare și panouri publicitare",
            "Ilustrații personalizate pentru print"
          ]
        },
        "visualContent": {
          "title": "Creare conținut vizual",
          "price": "Preț: €70/oră",
          "features": [
            "Design prezentare (de ex., PowerPoint, Keynote)",
            "Ilustrații personalizate",
            "Design iconițe",
            "Grafică social media",
            "Motion graphics (de ex., logo-uri animate)"
          ]
        },
        "specialized": {
          "title": "Servicii specializate",
          "price": "Preț: €70/oră",
          "features": [
            "Mockup produs",
            "Grafică stand expoziție",
            "Design meniu (de ex., pentru restaurante)",
            "Design tricou și articole vestimentare",
            "Vopsire vehicule"
          ]
        }
      }
    },
    "development": {
      "title": "DEZVOLTARE",
      "items": {
        "simpleLandingPage": {
          "title": "Dezvoltare pagină de destinație simplă",
          "price": "Interval de preț: €1.000–€2.000",
          "features": ["Design prietenos pentru mobile, SEO de bază și livrare rapidă"]
        },
        "websiteMaintenance": {
          "title": "Mentenanță website",
          "price": "Preț: €50–€100/oră",
          "features": ["Pentru actualizări minore sau reparații la cerere."]
        },
        "completeWebsiteRedesign": {
          "title": "Redesign complet website",
          "price": "Preț: €3.000+",
          "features": [
            "Reamenajare completă a unui website existent, inclusiv structură, branding și optimizare SEO."
          ]
        }
      }
    }
  },
  "modal": {
    "title": "-50% PENTRU PRIMELE VIDEOCLIPURI CORPORATIVE SAU DE RECRUTARE",
    "location": "*FILMĂRILE SUNT POSIBILE DOAR ÎN MÜNCHEN, GERMANIA (+ 100KM).",
    "howItWorks": {
      "title": "Cum funcționează?",
      "description": "După o scurtă discuție, se alege un video de prezentare a companiei sau un video de recrutare (~30 de secunde). Se stabilește data filmării, urmate de producție și editare.",
      "callout": "Potrivit pentru social media și marketing. O demonstrație de calitate, fără obligații."
    },
    "form": {
      "fullName": {
        "placeholder": "Nume complet"
      },
      "email": {
        "placeholder": "Email"
      },
      "submit": "Solicit oferta",
      "cancel": "Anulează"
    }
  }
}

